// extracted by mini-css-extract-plugin
module.exports = {"title":"connect-analytics_title__3wNxs","para":"connect-analytics_para__3YkgZ","separatorTitle":"connect-analytics_separatorTitle__1H1Dc"};